import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { AddBankSVG } from '../../../../svgComponents/addBankSVG';
import { AddCardSVG } from '../../../../svgComponents/addCardSVG';
import {
    ADD_PAYMENT_METHOD,
    CHOOSE_PAYMENT_METHOD_BANK_ACCOUNT
} from '../AddPaymentMethodModal.actions';
import messages from './ChoosePaymentMethod.messages';
import styles from './ChoosePaymentMethod.module.css';

const mapDispatchToProps = (dispatch: Dispatch) => ({
    goToLinkDebitCard: () =>
        dispatch({ type: ADD_PAYMENT_METHOD, paymentMethodType: 'DEBIT_CARD' }),
    goToLinkBankAccount: () =>
        dispatch({ type: CHOOSE_PAYMENT_METHOD_BANK_ACCOUNT })
});

type PropsFromRedux = ReturnType<typeof mapDispatchToProps>;

const ChoosePaymentMethod = ({
    goToLinkDebitCard,
    goToLinkBankAccount
}: PropsFromRedux) => {
    return (
        <>
            <div className={styles.ChoosePaymentMethod}>
                <div className={styles.title}>
                    <FormattedMessage {...messages.choosePaymentMethodTitle} />
                </div>
                <div className={styles.actions}>
                    <button
                        onClick={goToLinkDebitCard}
                        className={styles.debitCardBtn}
                    >
                        <AddCardSVG className={styles.debitCardSVG} />
                        <div className={styles.actionTitle}>
                            <FormattedMessage {...messages.debitCard} />
                            <div className={styles.actionDescription}>
                                <FormattedMessage
                                    {...messages.usedForRepayments}
                                />
                            </div>
                        </div>
                    </button>
                    <button
                        onClick={goToLinkBankAccount}
                        className={styles.bankAccountBtn}
                    >
                        <AddBankSVG />
                        <div className={styles.actionTitle}>
                            <FormattedMessage {...messages.bankAccount} />
                            <div className={styles.actionDescription}>
                                <FormattedMessage
                                    {...messages.usedForFundings}
                                />
                            </div>
                        </div>
                    </button>
                </div>
            </div>
        </>
    );
};

// eslint-disable-next-line import/no-default-export
export default connect(null, mapDispatchToProps)(ChoosePaymentMethod);
